import { useStoreState } from 'easy-peasy';
import {
  candidateFeedbacksSelector,
  candidateSelector,
} from '@model/Candidate/Candidate.selectors';
import { selectorUser } from '@model/User';
import type { TFeedbackMessage } from '@model/Candidate/Candidate.type';
import { format as dateFnsFormat } from 'date-fns';
import { jobStoreSelector } from '@model/Job/Job.selectors';
import { Trans, useTranslation } from 'react-i18next';
import type { TChatFeedbackMessage } from '@components/Molecules/Chat/Chat.types';
import type { TUser } from '@app/models/User';

export const useMessages = (): TChatFeedbackMessage[] => {
  const job = useStoreState(jobStoreSelector);
  const messages = useStoreState(candidateFeedbacksSelector);
  const candidate = useStoreState(candidateSelector);
  const user: TUser = useStoreState(selectorUser);

  const { t } = useTranslation('', {
    keyPrefix: 'candidateDetails.chat.message',
  });

  const { t: tCommon } = useTranslation('', {
    keyPrefix: 'common',
  });

  if (messages.length) {
    return messages;
  }

  const manager = job?.recruitmentConsultant ?? job?.salesConsultant;

  const authorFullName = tCommon('formatting.fullName', {
    firstName: manager?.firstName ?? '',
    lastName: manager?.lastName ?? '',
  });

  const baseDefaultMessage: Omit<TFeedbackMessage, 'content'> = {
    leftAt: dateFnsFormat(new Date(), 'yyyy-MM-dd HH:mm'),
    authorAvatar: manager?.avatarUrl ?? null,
    authorFullName,
    isAuthorHeadHunter: true,
  };

  if (!candidate || candidate.isLikedByClient === null) {
    return [
      {
        ...baseDefaultMessage,
        content: t('defaultMessageFeedback', {
          name: user.firstName,
        }),
      },
    ];
  }

  return [
    {
      ...baseDefaultMessage,
      content: (
        <Trans
          i18nKey="defaultMessageFeedback"
          t={t}
          context={candidate.isLikedByClient ? 'positive' : 'negative'}
          values={{
            name: user.firstName,
          }}
        />
      ),
    },
  ];
};
